// FILE: /src/Components/Social Desings/TikTokModal.js (FULLY UPDATED)

import React, { useState, useMemo } from 'react';
import { Skeleton } from 'antd';
import UserName from '../../Comman Components/UserName';
import Images from '../../Comman Components/Images';

export default function TikTokModal({ Previewimages: mediaItems = [], Previewcaptions = '', profile }) {
    const [open, setOpen] = useState(true);

    const isVideoPost = useMemo(() => mediaItems.length === 1 && mediaItems[0].type === 'video', [mediaItems]);
    const isPhotoPost = useMemo(() => mediaItems.length > 0 && mediaItems.every(item => item.type === 'image'), [mediaItems]);

    const videoUrl = isVideoPost ? (mediaItems[0]?.permanentUrl || mediaItems[0]?.localUrl) : null;
    const imageUrls = isPhotoPost ? mediaItems.map(item => item.permanentUrl || item.localUrl) : [];

    const renderMedia = () => {
        // --- START OF FIX ---
        // Handles different media types for the preview.

        if (isVideoPost && videoUrl) {
            return <video src={videoUrl} controls className="w-full h-auto max-h-96 object-contain bg-black rounded-lg" />;
        }
        
        if (isPhotoPost && imageUrls.length > 0) {
            // Display a grid for photo slideshows
            return (
                <div className="grid grid-cols-2 gap-1 bg-black rounded-lg">
                    {imageUrls.slice(0, 4).map((url, index) => (
                        <div key={index} className="aspect-square relative">
                            <img src={url} alt={`Slideshow item ${index + 1}`} className="w-full h-full object-cover" />
                            {index === 3 && imageUrls.length > 4 && (
                                <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
                                    <span className="text-white text-2xl font-bold">+{imageUrls.length - 4}</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            );
        }

        // Fallback skeleton if no valid media is available
        return <Skeleton.Image style={{ width: '100%', height: 400, borderRadius: 8 }} active />;
        
        // --- END OF FIX ---
    };

    return (
        <div className="w-full max-w-sm mx-auto my-4 border border-gray-300 rounded-xl">
            <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-3 font-semibold text-left">
                <div className="flex items-center gap-2">
                    <i className="fa-brands fa-tiktok text-black text-lg"></i>
                    <span>TikTok</span>
                </div>
                <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
            </button>

            {open && (
                <div className="border-t border-gray-200 p-3">
                     <div className="flex items-center gap-3 mb-2">
                        {profile ? <Images Id={profile.platform_id} /> : <Skeleton.Avatar active size="default" shape="circle" />}
                        <div className="font-semibold text-sm">
                            {profile ? <UserName Id={profile.platform_id} /> : <Skeleton.Input style={{ width: 120, height: 16 }} active size="small" />}
                        </div>
                    </div>
                    
                    <div className="text-sm whitespace-pre-wrap mb-3">
                        {Previewcaptions || <span className="text-gray-400 italic">Your caption will appear here...</span>}
                    </div>

                    <div className="relative bg-black rounded-lg">
                        {renderMedia()}
                    </div>
                </div>
            )}
        </div>
    );
}